export const scrollToView = (elemId: string) => {
  const todayTimeDivRef = document.querySelector("#" + elemId);
  if (todayTimeDivRef) {
    todayTimeDivRef.scrollIntoView({
      block: "start",
      behavior: "smooth",
    });
  }
};
